"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('../products');
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var enumeration_type_1 = require("../../enumeration-type");
var products_1 = require("../products");
var base_1 = require("../products/base");
var i0 = require("@angular/core");
var i1 = require("../products/products.service");
var VideoDeliverableService = /** @class */ (function (_super) {
    __extends(VideoDeliverableService, _super);
    function VideoDeliverableService(productsService) {
        var _this = _super.call(this, productsService, enumeration_type_1.DeliverableModule.Video) || this;
        _this.productsService = productsService;
        return _this;
    }
    VideoDeliverableService.ngInjectableDef = i0.defineInjectable({ factory: function VideoDeliverableService_Factory() { return new VideoDeliverableService(i0.inject(i1.ProductService)); }, token: VideoDeliverableService, providedIn: "root" });
    VideoDeliverableService = __decorate([ __metadata("design:paramtypes", [products_1.ProductService])
    ], VideoDeliverableService);
VideoDeliverableService.ɵfac = function VideoDeliverableService_Factory(t) { return new (t || VideoDeliverableService)(ɵngcc0.ɵɵinject(ɵngcc1.ProductService)); };
VideoDeliverableService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: VideoDeliverableService, factory: function (t) { return VideoDeliverableService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VideoDeliverableService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.ProductService }]; }, null); })();
    return VideoDeliverableService;
}(base_1.BaseProductsService));
exports.VideoDeliverableService = VideoDeliverableService;

